var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"ShBooleanValueMapper",style:({
    color: (_vm.props.value !== undefined
      ? _vm.props.value
      : true)
      ? _vm.props.asTrue
        ? _vm.props.asTrue.color || 'green'
        : 'green'
      : _vm.props.asFalse
        ? _vm.props.asFalse.color || 'red'
        : 'red',
    cursor: _vm.props.cursor || 'default',
  })},[_c('i',{class:("fa " + ((_vm.props.value !== undefined
          ? _vm.props.value
          : true)
          ? _vm.props.asTrue
            ? _vm.props.asTrue.icon || 'fa-check'
            : 'fa-check'
          : _vm.props.asFalse
            ? _vm.props.asFalse.icon || 'fa-times'
            : 'fa-times'))}),_vm._v("\n  "+_vm._s((_vm.props.value !== undefined
      ? _vm.props.value
      : true)
      ? _vm.props.asTrue
        ? _vm.props.asTrue.label || 'Yes'
        : 'Yes'
      : _vm.props.asFalse
        ? _vm.props.asFalse.label || 'No'
        : 'No')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }